import { render, staticRenderFns } from "./specialInfo.vue?vue&type=template&id=2c2e4e7a&scoped=true&"
import script from "./specialInfo.vue?vue&type=script&lang=js&"
export * from "./specialInfo.vue?vue&type=script&lang=js&"
import style0 from "./specialInfo.vue?vue&type=style&index=0&id=2c2e4e7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2e4e7a",
  null
  
)

export default component.exports